import { T } from "../../util/t";
import { Box, Typography } from "@mui/material";
import { useChipStyles } from "../forms/fields/useChipStyles";
import { useTranslate } from "../../providers/LocalizationProvider";

export const OrganisationContactChip = ({ organisation }) => {
    const classes = useChipStyles();
    const subject = useTranslate("enquiry_for_organisation", { name: organisation.name });

    return (
        <Box display="flex" mb={1}>
            <Typography variant="button"
                        className={classes.chip}
                        component="a"
                        href={`mailto:${organisation.contactEmail}?subject=${subject}`}>
                <T>Contact</T>
            </Typography>
        </Box>
    );
};
